import { render, staticRenderFns } from "./BatchTranslateTemplateImageModal.vue?vue&type=template&id=5be9464f&scoped=true"
import script from "./BatchTranslateTemplateImageModal.vue?vue&type=script&lang=js"
export * from "./BatchTranslateTemplateImageModal.vue?vue&type=script&lang=js"
import style0 from "./BatchTranslateTemplateImageModal.vue?vue&type=style&index=0&id=5be9464f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be9464f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be9464f')) {
      api.createRecord('5be9464f', component.options)
    } else {
      api.reload('5be9464f', component.options)
    }
    module.hot.accept("./BatchTranslateTemplateImageModal.vue?vue&type=template&id=5be9464f&scoped=true", function () {
      api.rerender('5be9464f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/BatchTranslateTemplateImageModal.vue"
export default component.exports